import $ from 'jquery';

let AUTOCOMPLETION_METADATA = {};

const tools = {
    isShowOnlyContent() {
        var isWordpress = window.location.pathname.startsWith("/wordpress");
        return isWordpress;
    },
    formatPhone(valueOld, valueNew) {
        let cleanNumber = valueNew.replace(/\D/g, '');

        const maxLength = 11;
        if (cleanNumber.length > maxLength) {
            cleanNumber = cleanNumber.slice(0, maxLength);
        }

        if (!cleanNumber) {
            return '';
        }
        
        let formattedNumber = '+7 ';
        if (cleanNumber.length == 1 && valueNew.length == 1) return `${formattedNumber}(${cleanNumber}`;
        if (cleanNumber.length == 1) return "";

        for (let i = 1; i < cleanNumber.length; i++) {
            if (i === 1) {
                formattedNumber += `(${cleanNumber[i]}`;
            } else if (i === 4) {
                formattedNumber += `) ${cleanNumber[i]}`;
            } else if (i === 7 || i === 9) {
                formattedNumber += `-${cleanNumber[i]}`;
            } else {
                formattedNumber += cleanNumber[i];
            }
        }

        return formattedNumber;
    },
    formatNumber(maxNumber, minNumber) {
        return function(valueOld, valueNew) {
            
            if (!minNumber) {
                minNumber = 0
            }

            let cleanStr = valueNew.replace(/[^\d-]|^(-)(?=\d)/g, '$1');
            var cleanNumber = cleanStr !== '' ? parseInt(cleanStr, 10).toString() : '';
            
            if (valueOld == '' && valueNew == "-" && minNumber < 0) {
                return "-"
            }

            if (cleanNumber !== '' && !isNaN(parseInt(cleanNumber, 10))) {
                cleanNumber = Math.min(Math.max(parseInt(cleanNumber, 10), minNumber), maxNumber).toString();
            } else {
                cleanNumber = '';
            }

            return cleanNumber;
        }
    },
    validatePhone(phone) {
        const requiredLength = 11;
        const foolproofPhone = phone.replace(/\D/g, ''); // Удаляем все символы, кроме цифр
        const hasError = foolproofPhone.length !== requiredLength;
        const errorMessage = ""; //hasError ? 'Номер телефона должен содержать 11 цифр' : '';
        return { hasError, errorMessage };
    },
    validateEmail(email) {
        let foolproofMail = tools.foolproofEmail(email);
        const hasError = !foolproofMail
        const errorMessage = ""; //hasError ? `Вы ввели не действительный email` : '';
        return { hasError, errorMessage };
    },
    foolproofEmail(email){
        email = email.toLowerCase();
        const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        return re.test(email);
    },
    translit(word){
        var converter = {
    
            'а': 'a',    'б': 'b',    'в': 'v',    'г': 'g',    'д': 'd',
    
            'е': 'e',    'ё': 'e',    'ж': 'zh',   'з': 'z',    'и': 'i',
    
            'й': 'y',    'к': 'k',    'л': 'l',    'м': 'm',    'н': 'n',
    
            'о': 'o',    'п': 'p',    'р': 'r',    'с': 's',    'т': 't',
    
            'у': 'u',    'ф': 'f',    'х': 'h',    'ц': 'c',    'ч': 'ch',
    
            'ш': 'sh',   'щ': 'sch',  'ь': '',     'ы': 'y',    'ъ': '',
    
            'э': 'e',    'ю': 'yu',   'я': 'ya'
    
        };
        word = word.toLowerCase();
        var answer = '';
        for (var i = 0; i < word.length; ++i ) {
    
            if (converter[word[i]] == undefined){
    
                answer += word[i];
    
            } else {
    
                answer += converter[word[i]];
    
            }
    
        }
        answer = answer.replace(/[^-0-9a-z]/g, '-');
        answer = answer.replace(/[-]+/g, '-');
        answer = answer.replace(/^-|-$/g, '');
        return answer;
    },
    openFAQmenu(AMOUNT_OF_FAQS) {
        for (let i = 1; i < AMOUNT_OF_FAQS + 1; ++i) {
            (function () {
              var div = document.getElementById('detailsummary' + i);
              if (div) {
                var opening = $('#detail' + i);
                var opening_docsel = document.getElementById('detail' + i);
                var inner = $('#detailtext' + i);
                var icon = document.getElementById('detailarrow' + i);
                div.addEventListener('click', function (e) {
                  e.preventDefault();
                  if (opening.hasClass('open')) {
                    icon.className = 'fa fa-arrow-down';
                    div.className = 'fa fa-color';
                    opening.css('max-height', 0);
                  } else {
                    icon.className = 'fa fa-arrow-down open';
                    div.className = 'fa fa-color open'
                    inner.show();
                    opening.css('max-height', opening_docsel.scrollHeight)
                  }
                  opening.toggleClass('open closed')
                });
              } else {
                console.error("Element with ID 'detailsummary" + i + "' not found.");
              }
            }());
        }  
    },
    console_log(a) {
        console.log(a)
    },
    get_url() {
        return document.URL;
    },
    
    get_data(url) {
        var get_data = url.split('?');
        if (get_data.length > 1) {
            var data = get_data[1];
            return data.split('&');
        }
        else {
            return null
        }
    },
    
    translateStatusIntoShorter(current_status) {
        if (current_status == "Отменен Исполнителем") {
            current_status = "Отказ";
        } else if (current_status == "Отменен Заказчиком") {
            current_status = "Отмена";
        } else if (current_status == "Выполнение просрочено") {
            current_status = "Просрочен";
        }
        return current_status;
    },
    statusToString(statusRaw) {
        const STATUSES = [
            "Создан",
            "???",
            "Запланирован",
            "Выезд",
            "Выполняется",
            "Выполнен",
            "Отказ исполнителя",
            "Не подтверждён",
            "Отменён заказчиком",
            "Отменён исполнителем",
            "Перенесён",
            "Приостановлен",
            "Выполнение просрочено",
        ];
        try {
            const stat = parseInt(`${statusRaw}`);
            return STATUSES[stat]
        } catch {
            return "Неизвестный статус";
        }
    },
    statusFromString(statusRaw) {
        const STATUSES = [
            "создан",
            "???",
            "запланирован",
            "выезд",
            "выполняется",
            "выполнен",
            "отказ исполнителя",
            "не подтверждён",
            "отменен заказчиком",
            "отменен исполнителем",
            "перенесён",
            "приостановлен",
            "выполнение просрочено",
        ];
        try {
            return STATUSES.indexOf(`${statusRaw}`.toLowerCase());
        } catch {
            return -1;
        }
    },
    getDaysWord(days) {
        if (days % 10 === 1 && days % 100 !== 11) {
            return 'день';
        } else if ([2, 3, 4].includes(days % 10) && ![12, 13, 14].includes(days % 100)) {
            return 'дня';
        } else {
            return 'дней';
        }
    },
    getHoursWord(hours) {
        if (hours % 10 === 1 && hours % 100 !== 11) {
            return 'час';
        } else if ([2, 3, 4].includes(hours % 10) && ![12, 13, 14].includes(hours % 100)) {
            return 'часа';
        } else {
            return 'часов';
        }
    },
    getMinutesWord(minutes) {
        if (minutes % 10 === 1 && minutes % 100 !== 11) {
            return 'минута';
        } else if ([2, 3, 4].includes(minutes % 10) && ![12, 13, 14].includes(minutes % 100)) {
            return 'минуты';
        } else {
            return 'минут';
        }
    },
    compareDates(date1, date2, addDay, addMonth, addYear) {
        if (!addDay) addDay = 0;
        if (!addMonth) addMonth = 0;
        if (!addYear) addYear = 0;
        return date1.getFullYear() + addYear == date2.getFullYear() &&
               date1.getMonth() + addMonth == date2.getMonth() &&
               date1.getDate() + addDay == date2.getDate();
    },
    datePrettyText(dateText) {
        var parts = dateText.split(".").map(x => parseInt(x));
        var dateDate = new Date(parts[2], parts[1] - 1, parts[0]);
        var today = new Date();
        if (this.compareDates(dateDate, today)) return "Сегодня";
        if (this.compareDates(dateDate, today, -1)) return "Завтра";
        return dateText;
    },
    timePrettyText(dateText, timeText) {
        var partsDate = dateText.split(".").map(x => parseInt(x));
        var partsTime = timeText.split(":").map(x => parseInt(x));
        var dateTime = new Date(partsDate[2], partsDate[1] - 1, partsDate[0], partsTime[0], partsTime[1])
        var today = new Date();
        if (dateTime.getTime() - today.getTime() < 15 * 60 * 1000) return "Ближайшее";
        return timeText;
    },

    getNowDate(element) {
        element = document.getElementById(element)
        if (element.value == '') {
            if (element.type == 'date') {
                element.value = tools.todayInString()
            } else if (element.type == 'time') {
                var nowTime = new Date().toLocaleTimeString('ru-RU', { hour12: false, hour: "numeric", minute: "numeric"});
                element.value = nowTime
            }
        }
    
    },

    setToDefault() {
        if (document.getElementById("first__date")) document.getElementById("first__date").value = "";
        if (document.getElementById("second__date")) document.getElementById("second__date").value = "";
        if (document.getElementById("first__time")) document.getElementById("first__time").value = "";
        if (document.getElementById("second__time")) document.getElementById("second__time").value = "";
        if (document.getElementById("search_adress")) document.getElementById('search_adress').value = "";
        if (document.getElementById("organisation_name")) document.getElementById('organisation_name').value = "";
        if (document.getElementById("veh__check_1")) document.getElementById('veh__check_1').checked = true;
        if (document.getElementById("type__check_1")) document.getElementById('type__check_1').checked = true;
        if (document.getElementById("patient__check_1")) document.getElementById('patient__check_1').checked = false;
        if (document.getElementById("patient__check_2")) document.getElementById('patient__check_2').checked = false;
        if (document.getElementById("patient__check_3")) document.getElementById('patient__check_3').checked = false;
        if (document.getElementById("date1")) document.getElementById('date1').checked = false;
        if (document.getElementById("date2")) document.getElementById('date2').checked = false;
        if (document.getElementById("date3")) document.getElementById('date3').checked = false;
        if (document.getElementById("toggle")) document.getElementById("toggle").checked = false;
        $("#order_status_option1").click()
    },
    
    getNowYear() {
        var date = new Date()
        return date.getFullYear() 
    },

    isValidDate(dateString) {
        var birthDate = new Date(dateString);
        var validDate = new Date()
        var day = ("0" + birthDate.getDate()).slice(-2);
        var month = ("0" + (birthDate.getMonth() + 1)).slice(-2);
        var year = birthDate.getFullYear();
        return year == validDate.getFullYear() && month == validDate.getMonth() && day == validDate.getDate();
    },

    clickKeepNumber(numberString, from, to) {
        var currentNum = numberString.replace(/[^0-9-]/g, '');
        if (currentNum.length == 0) return "" //currentNum = "0";
        if (currentNum == "-") {
            if (from < 0) {
                return "-"
            } else {
                return ""
            }
        }
        currentNum = parseInt(currentNum);

        //if (currentNum == "777") return currentNum;
        if (from && currentNum < from) currentNum = from;
        if (to && currentNum > to) currentNum = to;
        return currentNum;
    },


    _addAutocompletionHtml(elementId, all_options) {
        var my_datalist = document.getElementById(elementId + "_datalist");
        while (my_datalist.firstChild) {
            my_datalist.firstChild.remove()
        }
        for (let i in all_options) {
            var new_option = document.createElement('option');
            new_option.setAttribute("id", elementId + "_datalist_option" + i);
            new_option.setAttribute("value", all_options[i]);
            my_datalist.appendChild(new_option);
        }
    },
    addAutocompletion(elementId, typeOfData) {
        $(document).ready(function() {
            if (AUTOCOMPLETION_METADATA[elementId] == null) {
                var new_datalist = document.createElement('datalist');
                new_datalist.setAttribute("id", elementId + "_datalist");
                new_datalist.setAttribute("display", "none");
                document.getElementById(elementId).appendChild(new_datalist);
                //$("#" + elementId).focus();
            }
            $("#" + elementId).keyup(function(ev) {
                if (AUTOCOMPLETION_METADATA[ev.target.id] == ev.target.value) return;
                AUTOCOMPLETION_METADATA[ev.target.id] = ev.target.value;

                $.ajax({
                    type: "GET",
                    url: global.BACKEND_URL + `/get_` + typeOfData + `?start=${ev.target.value}&from=0&to=5`,
                    success: function (data) {
                        tools._addAutocompletionHtml(ev.target.id, data)
                    },
                    error: function () { },
                    dataType: "json",
                    contentType: "application/json"
                });
            });
        });
    },
    
    
    daysInMonth (month, year) {
        return new Date(year, month, 0).getDate();
    },
    
    setNowDay() {
        var today = tools.todayInString();
    
        $('#first__date').val(today);
        $('#second__date').val(today);
        $('#first__time').val('00:00')
        $('#second__time').val('23:59')
    },

    prettyDateTime(datetime) {
        if (datetime == null) return "";
        var hours = `00${datetime.getHours()}`.slice(-2);
        var minutes = `00${datetime.getMinutes()}`.slice(-2);
        return (`${datetime.getDate()}-${datetime.getMonth()+1}-${datetime.getFullYear()}, ` +
                `${hours}:${minutes}`)
    },
 
    setNowMonth() {
        var now = new Date();
    
        var month = ("0" + (now.getMonth() + 1)).slice(-2);
        var first_day = ("01");
        var first_today = now.getFullYear()+"-"+(month)+"-"+(first_day);
        var second_day = tools.daysInMonth(month, now.getFullYear())
        var nextDate = now.getFullYear()+"-"+(month)+"-"+(second_day);
    
        $('#first__date').val(first_today);
        $('#second__date').val(nextDate);
        $('#first__time').val('00:00')
        $('#second__time').val('23:59')
    },
    
    setLastWeek() {
        var now = tools.todayInString();
        var nextDate = tools.dateInString(new Date(Date.now() - 604800000));

        $('#first__date').val(nextDate);
        $('#second__date').val(now);
        $('#first__time').val('00:00')
        $('#second__time').val('23:59')
    },
    getAge(dateString){
        var today = new Date();
        var birthDate = new Date(dateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
        return age;
    },
    parseDashDate(date_string) {
        var parts = date_string.split("-");
        var dt = new Date(parseInt(parts[0], 10),
                          parseInt(parts[1], 10) - 1,
                          parseInt(parts[2], 10));
        return dt;
    },
    inputDateKeyUp(el_id, before_today) {
        const TODAY_STRING = tools.todayInString();
        // before_today = true if el_id should be earlier than today, false if later today
        var el = $("#" + el_id)
        var c_date = el.val();
        if (!c_date) c_date = TODAY_STRING;
        // extract separate parts
        var c_day = c_date
        var c_year = c_day.substr(0, c_day.indexOf("-"))
        c_day = c_day.substr(c_day.indexOf("-") + 1)
        var c_month = c_day.substr(0, c_day.indexOf("-"))
        c_day = c_day.substr(c_day.indexOf("-") + 1)
        // foolproof
        if (c_date.length > 10) {
            el.blur()
            el.focus()
            c_year = c_year.substr(0, 4)
            c_date = c_year + "-" + c_month + "-" + c_day
            if (before_today == true && tools.parseDashDate(c_date) > new Date()) {
                c_date = TODAY_STRING;
            } else if (before_today == false && tools.parseDashDate(c_date) < new Date()) {
                c_date = TODAY_STRING;
            }
        }
        // set
        el.val(c_date);
    },
    inputDateLoseFocus(el_id, before_today) {
        const TODAY_STRING = tools.todayInString();
        // before_today = true if el_id should be earlier than today, false if later today
        var el = $("#" + el_id)
        var c_date = el.val();
        if (!c_date) c_date = TODAY_STRING;
        if (before_today == true && tools.parseDashDate(c_date) > new Date()) {
            c_date = TODAY_STRING;
        } else if (before_today == false && tools.parseDashDate(c_date) < new Date()) {
            c_date = TODAY_STRING;
        }
        // set
        el.val(c_date);
    },

    withLeadingSymbols(string, symbol, amount) {
        if (symbol == null) {
            symbol = "0";
        }
        if (amount == null) {
            amount = 2;
        }
        return (symbol.repeat(amount) + string).slice(-amount);
    },
    formatDate(date, format) {
        var months = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];
        var replaces = {
            YYYY: date.getFullYear(),
            YY: `${date.getFullYear()}`.substring(2),
            Mmmm: months[date.getMonth()],
            Mmm: months[date.getMonth()].substring(0, 3),
            MMMM: months[date.getMonth()].toLowerCase(),
            MM: this.withLeadingSymbols(date.getMonth() + 1),
            dd: this.withLeadingSymbols(date.getDate()),
            hh: this.withLeadingSymbols(date.getHours()),
            mm: this.withLeadingSymbols(date.getMinutes()),
            ss: this.withLeadingSymbols(date.getSeconds()),
        };
        for (const type in replaces) {
            format = format.replace(type, replaces[type]);
        }
        return format;
    },
    timeInString(curDate) {
        return this.formatDate(curDate, "hh:mm");
    },
    dateInString(curDate) {
        return this.formatDate(curDate, "dd.MM.YYYY");
    },
    todayInString() {
        return tools.dateInString(new Date());
    },

    selectedOpenClose(select_box_name) {
        if (document.getElementById(select_box_name + "_select_box").classList.contains('opened')) {
            document.getElementById(select_box_name + "_select_box").classList.remove("opened");
            document.getElementById(select_box_name + "_options").style.display = "none";
        }
        else {
            document.getElementById(select_box_name + "_select_box").classList.add("opened")
            document.getElementById(select_box_name + "_options").style.display = "flex";
        }
    },
    selectOptionsChoose(select_box_name, select_box_option, amount_of_all_options) {
        document.getElementById(select_box_name + "_options").style.display = "none";
        for (let selboxoption = 1; selboxoption <= amount_of_all_options; selboxoption++) {
            if (selboxoption == select_box_option) {
                document.getElementById(select_box_name + "_option" + selboxoption).classList.add("current");
            } else {
                document.getElementById(select_box_name + "_option" + selboxoption).classList.remove("current");
            }
        }
        document.getElementById(select_box_name + "_index").innerText = '0';
        document.getElementById(select_box_name + "").innerText = document.getElementById(select_box_name + "_option" + select_box_option + "_text").innerText;
        document.getElementById(select_box_name + "_select_box").classList.remove("opened")
    },

    addrSuffixElevatorFloorDispatcher(is_elevator, is_freight_elevator, floor) {
        var from_address_add_info = "";
        if (!Number.isNaN(floor)) {
            from_address_add_info += ", этаж " + floor
            if (floor == 1) return from_address_add_info;
        }
        if (!is_elevator) from_address_add_info += ", без лифта"
        if (is_elevator) {
            if (is_freight_elevator) {
                from_address_add_info += ", с грузовым лифтом"
            } else {
                from_address_add_info += ", с лифтом, без грузового"
            }
        }
        return from_address_add_info
    },

    ageStr(ageNum) {
        if ((ageNum % 100) >= 10 && (ageNum % 100) <= 14) return "лет"
        if ((ageNum % 10) == 1) return "год"
        if ((ageNum % 10) > 1 && (ageNum % 10) <= 4) return "года"
        return "лет"
    },

    filterOnlyUnique(arr, hashFoo) {
        var existing = new Set();
        var newArr = [];
        for (var el of arr) {
            var h = hashFoo(el);
            if (!existing.has(h)) {
                newArr.push(el);
                existing.add(h);
            }
        }
        return newArr;
    },

    regAddrToString(intermediate, addr, label) {
        const joinedArr = [intermediate, addr, label].filter(Boolean).map(x => x.split(', ')).join().split(',');
        return [...new Set(joinedArr)].join(', ');
    },
    stringToRegAddr(string) {
        var i = string.indexOf(",");
        return [string.substring(0, i), string.substring(i+2)];
    },
    concatPoint(string, coords) {
        return string + `, координаты (${coords.lat}, ${coords.lon})`;
    },
    extractPoint(string) {
        string = string.substring(string.indexOf("долгота: ") + 9, string.length - 1);
        var res = string.split(", широта: ").map(x => parseFloat(x));
        return res.reverse();
    },

    formatTimestamp(timestamp, format, dateFormat) {
        if (dateFormat == null) {
            if (format == "number") {
                dateFormat = "dd.MM.YYYY hh:mm:ss";
            } else {
                dateFormat = "dd Mmmm YYYY, hh:mm";
            }
        }
        var date = new Date(timestamp);
        var timeZoneOffset = -(date.getTimezoneOffset() / 60);
        try {
            switch (format) {
                case 'number':
                    return this.formatDate(date, dateFormat);
                case 'text':
                    return this.formatDate(date, dateFormat) + ' (UTC' + (timeZoneOffset >= 0 ? '+' : '') + timeZoneOffset + ')';
                default:
                    return 'Неверный формат';
            }
        } catch {
            return 'Неверный формат';
        }
    },
    saveForm(name, data, expire_ms) {
        if (!expire_ms) {
            expire_ms = 30 * 60 * 1000;
        }
        const item = {
            data: data,
            expiry: (new Date()).getTime() + expire_ms,
        };
        localStorage.setItem(name, JSON.stringify(item));
    },
    loadForm(name) {
        try {
            var item = JSON.parse(localStorage.getItem(name));
            if ((new Date()).getTime() > item.expiry) {
                localStorage.removeItem(name);
                return null;
            }
            return item.data;
        } catch {
            return null;
        }
    },
    mergeIntoObject(obj, other) {
        for (var key in other) {
            obj[key] = other[key]
        }
    },
}

export default tools;
